import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React from 'react';
import CheckoutForm from './PaymentMethodForm'
// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE);

const Stripes = ({ clientSecret, successCB, loadingCB, failCB, paymentMethod }) => {
    const options = {
        clientSecret: clientSecret,
    };

    return (
        <Elements stripe={stripePromise} options={options}>
            <CheckoutForm paymentMethod={paymentMethod} successCB={successCB} loadingCB={loadingCB} failCB={failCB} clientSecret={clientSecret}/>
        </Elements>
    );
};

export default Stripes